// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"notFound_wrapper__3-GNY","text":"notFound_text__7cLTP"};